import { Breakpoints } from './movax/Breakpoints';
import { Images } from './movax/Images';
import { Events } from './movax/Events';
import { DOM } from './movax/DOM';
import { Storage } from './movax/Storage';
import { Geolocation } from './movax/Geolocation';
import { XHR } from './movax/XHR';

/**
 * All helper singletons combined
 */
export module Movax {
  export const breakpoints = Breakpoints;
  export const images = Images;
  export const events = Events;
  export const dom = DOM;
  export const geolocation = Geolocation;
  export const storage = Storage;
  export const xhr = XHR;
}
